<script>
  import TaskItemMinimized from "./TaskItemMinimized.svelte";
  import { Task } from "../../classes/task.js";
  import { onMount } from "svelte";
  import { user } from "../../firebase";
  import CreateTask from "../../components/createTask.svelte";
  import { baseAPIUrl } from "../../globals";
  import { authenticatedFetch } from "../../appbridge";
  import { doc } from "@firebase/firestore";
  import { conversion, lang } from "../../store/store";

  import { active } from "tinro";
  let tasks;
  export let createTask;
  let predefined = [
    {
      name: $conversion[$lang].MyTasks.SubTitles[2],
      color: "#FF7800",
      init_color: "#EEDAC8",
    },
    {
      name: $conversion[$lang].MyTasks.SubTitles[3],
      color: "#04A9F4",
      init_color: "#C9E1ED",
    },
    {
      name: $conversion[$lang].MyTasks.SubTitles[4],
      color: "#6BC950",
      init_color: "#D8E6D4",
    },
  ];

  let hover = "";

  $user.tasks.subscribe((v) => {
    tasks = Object.entries(v);
    tasks = tasks;
    console.log(tasks);

    console.log(tasks);
  });
  let img;
  let userinfo;
  $user.doc.subscribe((v) => {
    img = v.account.img;
    userinfo = v;
  });
  let err = false;

  let convert = (k) => {
    k = Math.abs(k);
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    if (hrs != 0) {
      output = hrs + " " + " H";
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output = output + " " + minutes + " M";
      } else {
        output = output + minutes + " " + " M";
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + " M";
    }
    return output;
  };

  /*     onMount(async () => {
  import TaskItemMinimized from "./TaskItemMinimized.svelte";
  import { Task } from "../../classes/task.js";
  import { onMount } from "svelte";
  import { user } from "../../firebase";
  import CreateTask from "../../components/createTask.svelte";
  import { baseAPIUrl } from "../../globals";
  import { authenticatedFetch } from "../../appbridge";
  import { doc } from "@firebase/firestore";
  import { active } from "tinro";
  let tasks;
  let createTask = false;
  let predefined = [
    {
      name: "In dev",
      color: "#FF7800",
      init_color: "#EEDAC8",
    },
    {
      name: "To review",
      color: "#04A9F4",
      init_color: "#C9E1ED",
    },
    {
      name: "Done",
      color: "#6BC950",
      init_color: "#D8E6D4",
    },
  ];

  let hover = "";

  $user.tasks.subscribe((v) => {
    tasks = Object.entries(v);
    tasks = tasks;
    console.log(tasks);

    console.log(tasks);
  });
  let img;
  let userinfo;
  $user.doc.subscribe((v) => {
    img = v.account.img;
    userinfo = v;
  });
  let err = false;

  /*     onMount(async () => {
        tasks = await Task.fromShop;
        console.log("dsqdsqd");
        console.log(Object.entries(tasks));
    }); */
  let Estimate = (task) => {
    console.log(task);
    if (
      task?.estimation?.minEst &&
      task?.estimation?.maxEst &&
      task?.estimation?.minDel &&
      task?.estimation?.maxDel
    ) {
      return (
        convert(task.estimation.minEst) +
        " - " +
        convert(task.estimation.maxEst)
      );
    }
    return { en: "Estimating", fr: "Estimation" }[$lang];
  };

  async function handleApproval(a) {
    let min = a.custom_fields[0].value.replaceAll("h", "");
    min = parseInt(a.custom_fields[0].value.replaceAll("m", ""));
    let max = a.custom_fields[1].value.replaceAll("h", "");
    max = parseInt(a.custom_fields[1].value.replaceAll("m", ""));
    let avg = (min + max) / 2;
    if (userinfo.availableHrs < avg) {
      console.log(err);
      err = true;
      console.log(err);
      return;
    }
    let response = await authenticatedFetch(
      baseAPIUrl + "/clickup/approveTask",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: a,
          currentHrs: userinfo.availableHrs,
          capturedHrs: avg,
        }),
      }
    ).then((response) => {
      return response.json();
    });
  }

  console.log("---------------------- TESTING PHASE ----------------------");
  let testParah = tasks[0][1].description;
  if (testParah) {
    let newStr1 = testParah.replace("<p>", "");
    let newStr = newStr1.replace("</p>", "");
    console.log(newStr);
  }

  function paragraphCleaner(parag) {
    if (testParah) {
      let testParah = parag;
      let newStr1 = testParah.replace("<p>", "");
      let newStr = newStr1.replace("</p>", "");
      // console.log(newStr);
      return newStr;
    }
  }

  // console.log(tasks[0][1].description);
</script>

<div class="t-wrapper">
  <div class="t-container">
    <div class="t-ctn-line" />
    <div class="row top">
      <div class="t-title">{$conversion[$lang].MyTasks.SubTitles[1]}</div>
      <div
        on:click={() => {
          createTask = true;
        }}
        class="add-img"
      >
        +
      </div>
    </div>
    <div class="tasksLoadingList">
      {#each tasks as task}
        {#if task[1].status.orderindex == 0 || task[1].status.orderindex == 1 || task[1].status == 0}
          <a
            href="/TaskItemDetails/{task[1].taskid}"
            class:onHover={hover == task[1].taskid}
            on:focus
            on:blur
            on:mouseout={() => {
              hover = "";
            }}
            on:mouseover={() => {
              hover = task[1].taskid;
            }}
            class="task-ctn"
          >
            <div class="row flex-start">
              <div class="column">
                <div class="task-id">{task[1].taskid}</div>
                <div class="task-name">{task[1].name}</div>
              </div>
            </div>
            <div class="task-description">
              {paragraphCleaner(task[1].description).substring(0, 50)}
              {#if paragraphCleaner(task[1].description).length > 50}...{/if}

              <!-- {@html task[1].description} -->
              <!-- <h1>
              {@html task[1].description.slice(4)}
            </h1> -->
            </div>
            <div class="row comments">
              <div class="user-img"><img src={img} alt="" /></div>
              <div class="task-comments">
                {Object.entries(task[1]?.messages || {})?.length || 0}
                {$conversion[$lang].MyTasks.comment}
              </div>
              <a
                href="/TaskItemDetails/{task[1].taskid}"
                class="task-read"
                class:unread={task[1].unread}
              >
                <img src="../images/tasks/comment.svg" alt="" />
              </a>
            </div>
            <div class="row">
              <div class="row t-estimate">
                <div class="estimate-clock">
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      class="clock"
                      d="M10.3395 8.79592L7.55387 6.84797V3.50002C7.55387 3.34223 7.42477 3.21313 7.26699 3.21313C7.1092 3.21313 6.9801 3.34223 6.9801 3.50002V7.00002C6.9801 7.09469 7.026 7.18076 7.10346 7.23527L10.0125 9.26928C10.0612 9.30371 10.1186 9.32092 10.176 9.32092C10.2649 9.32092 10.3539 9.27789 10.4112 9.19469C10.5002 9.06559 10.4686 8.88773 10.3395 8.79592Z"
                    />
                    <path
                      class="clock"
                      d="M12.2129 2.0541C10.8875 0.72869 9.13172 0 7.26697 0C5.40221 0 3.64648 0.72869 2.32107 2.0541C0.995656 3.37951 0.266968 5.13525 0.266968 7C0.266968 8.86475 0.995656 10.6205 2.32107 11.9459C3.64648 13.2713 5.40221 14 7.26697 14C9.13172 14 10.8875 13.2713 12.2129 11.9459C13.5383 10.6205 14.267 8.86475 14.267 7C14.267 5.13525 13.5383 3.37951 12.2129 2.0541ZM7.55385 13.4205V12.25C7.55385 12.0922 7.42475 11.9631 7.26697 11.9631C7.10918 11.9631 6.98008 12.0922 6.98008 12.25V13.4205C3.66369 13.2742 0.992787 10.6033 0.846476 7.28689H2.01697C2.17475 7.28689 2.30385 7.15779 2.30385 7C2.30385 6.84221 2.17475 6.71311 2.01697 6.71311H0.846476C0.992787 3.39672 3.66369 0.72582 6.98008 0.579509V1.75C6.98008 1.90779 7.10918 2.03689 7.26697 2.03689C7.42475 2.03689 7.55385 1.90779 7.55385 1.75V0.579509C10.8702 0.72582 13.5411 3.39672 13.6875 6.71311H12.517C12.3592 6.71311 12.2301 6.84221 12.2301 7C12.2301 7.15779 12.3592 7.28689 12.517 7.28689H13.6875C13.5411 10.6033 10.8702 13.2742 7.55385 13.4205Z"
                    />
                  </svg>
                </div>
                <div class="task-estimate">{Estimate(task[1])}</div>
              </div>
              <div class="task-priority">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="var(--priority{task[1].priority.name})"
                >
                  <path
                    d="M15.4109 1.51094C15.05 1.33056 14.6179 1.3695 14.2951 1.61173C13.0492 2.5465 11.8438 2.16549 9.98044 1.4664C8.15422 0.781372 5.88157 -0.0710914 3.63854 1.61173C3.37037 1.81294 3.21252 2.12868 3.21252 2.46398V8.80934C3.21252 9.21293 3.44058 9.5819 3.80161 9.76238C4.16263 9.94287 4.59467 9.90377 4.9174 9.66159C6.16327 8.72682 7.36867 9.10783 9.23202 9.80692C10.2715 10.1968 11.4556 10.641 12.6965 10.641C13.6358 10.641 14.6076 10.3866 15.5739 9.66159C15.8421 9.46038 15.9999 9.14464 15.9999 8.80934V2.46398C15.9999 2.06039 15.7719 1.69142 15.4109 1.51094Z"
                    fill="var(--priority{task[1].priority.name})"
                  />
                  <path
                    d="M1.06544 0.416626C0.477 0.416626 0 0.893626 0 1.48207V14.5181C0 15.1065 0.477 15.5835 1.06544 15.5835C1.65389 15.5835 2.13089 15.1065 2.13089 14.5181V1.48207C2.13089 0.893626 1.65389 0.416626 1.06544 0.416626Z"
                    fill="var(--priority{task[1].priority.name})"
                  />
                </svg>
              </div>
            </div>
            {#if task[1].approval == false}
              <a
                href="/TaskItemDetails/{task[1].taskid}"
                class="row t-approval"
                class:err
              >
                <img src="../images/tasks/check.svg" alt="" />
                <div class="task-approval">
                  {$conversion[$lang]?.tasks?.MinimizedTasksView
                    ?.waitingApproval || "Waiting for your approval"}
                </div>
              </a>
            {/if}
          </a>
        {/if}
      {/each}
    </div>
  </div>
  {#each predefined as option, i}
    <div class="t-container">
      <div style="background-color:{option.color}" class="t-ctn-line" />
      <div class="row top">
        <div class="t-title">{option.name}</div>
      </div>
      <div class="tasksLoadingList">
        {#each tasks as task}
          {#if task[1].status.orderindex == i + 2 && task[1].status.status != "declined"}
            <a
              href="/TaskItemDetails/{task[1].taskid}"
              style="background-color:{hover == task[1].taskid
                ? option.color
                : option.init_color};border:1px solid {option.color}"
              class:onHover={hover == task[1].taskid}
              on:focus
              on:blur
              on:mouseout={() => {
                hover = "";
              }}
              on:mouseover={() => {
                hover = task[1].taskid;
              }}
              class="task-ctn"
            >
              <div class="row flex-start">
                <div class="column">
                  <div class="task-id">{task[1].taskid}</div>
                  <div class="task-name">{task[1].name}</div>
                </div>
              </div>
              <div class="task-description">
                <!-- {@html task[1].description} -->
                {paragraphCleaner(task[1].description).substring(0, 50)}
                {#if paragraphCleaner(task[1].description).length > 50}...{/if}
              </div>
              <div class="row comments">
                <div class="user-img">
                  <img
                    src={img ||
                      "https://firebasestorage.googleapis.com/v0/b/expertify-tasks-dev.appspot.com/o/assets%2Fuser.png?alt=media&token=c7eff643-3c19-47a0-8ddf-0150f58de8f8"}
                    alt=""
                  />
                </div>
                <div class="task-comments">
                  {Object.entries(task[1]?.messages || {})?.length || 0}
                  {$conversion[$lang].MyTasks.comment}
                </div>
                <a
                  href="/TaskItemDetails/{task[1].taskid}"
                  class="task-read"
                  class:unread={task[1].unread}
                >
                  <img src="../images/tasks/comment.svg" alt="" />
                </a>
              </div>
              <div class="row">
                <div
                  style="background-color:{hover == task[1].taskid
                    ? 'white'
                    : option.color}"
                  class="row t-estimate"
                >
                  <div class="estimate-clock">
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="clock"
                        d="M10.3395 8.79592L7.55387 6.84797V3.50002C7.55387 3.34223 7.42477 3.21313 7.26699 3.21313C7.1092 3.21313 6.9801 3.34223 6.9801 3.50002V7.00002C6.9801 7.09469 7.026 7.18076 7.10346 7.23527L10.0125 9.26928C10.0612 9.30371 10.1186 9.32092 10.176 9.32092C10.2649 9.32092 10.3539 9.27789 10.4112 9.19469C10.5002 9.06559 10.4686 8.88773 10.3395 8.79592Z"
                      />
                      <path
                        class="clock"
                        d="M12.2129 2.0541C10.8875 0.72869 9.13172 0 7.26697 0C5.40221 0 3.64648 0.72869 2.32107 2.0541C0.995656 3.37951 0.266968 5.13525 0.266968 7C0.266968 8.86475 0.995656 10.6205 2.32107 11.9459C3.64648 13.2713 5.40221 14 7.26697 14C9.13172 14 10.8875 13.2713 12.2129 11.9459C13.5383 10.6205 14.267 8.86475 14.267 7C14.267 5.13525 13.5383 3.37951 12.2129 2.0541ZM7.55385 13.4205V12.25C7.55385 12.0922 7.42475 11.9631 7.26697 11.9631C7.10918 11.9631 6.98008 12.0922 6.98008 12.25V13.4205C3.66369 13.2742 0.992787 10.6033 0.846476 7.28689H2.01697C2.17475 7.28689 2.30385 7.15779 2.30385 7C2.30385 6.84221 2.17475 6.71311 2.01697 6.71311H0.846476C0.992787 3.39672 3.66369 0.72582 6.98008 0.579509V1.75C6.98008 1.90779 7.10918 2.03689 7.26697 2.03689C7.42475 2.03689 7.55385 1.90779 7.55385 1.75V0.579509C10.8702 0.72582 13.5411 3.39672 13.6875 6.71311H12.517C12.3592 6.71311 12.2301 6.84221 12.2301 7C12.2301 7.15779 12.3592 7.28689 12.517 7.28689H13.6875C13.5411 10.6033 10.8702 13.2742 7.55385 13.4205Z"
                      />
                    </svg>
                  </div>
                  <div class="task-estimate">{Estimate(task[1])}</div>
                </div>
                <div class="task-priority">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="var(--priority{task[1].priority.name})"
                  >
                    <path
                      d="M15.4109 1.51094C15.05 1.33056 14.6179 1.3695 14.2951 1.61173C13.0492 2.5465 11.8438 2.16549 9.98044 1.4664C8.15422 0.781372 5.88157 -0.0710914 3.63854 1.61173C3.37037 1.81294 3.21252 2.12868 3.21252 2.46398V8.80934C3.21252 9.21293 3.44058 9.5819 3.80161 9.76238C4.16263 9.94287 4.59467 9.90377 4.9174 9.66159C6.16327 8.72682 7.36867 9.10783 9.23202 9.80692C10.2715 10.1968 11.4556 10.641 12.6965 10.641C13.6358 10.641 14.6076 10.3866 15.5739 9.66159C15.8421 9.46038 15.9999 9.14464 15.9999 8.80934V2.46398C15.9999 2.06039 15.7719 1.69142 15.4109 1.51094Z"
                      fill="var(--priority{task[1].priority.name})"
                    />
                    <path
                      d="M1.06544 0.416626C0.477 0.416626 0 0.893626 0 1.48207V14.5181C0 15.1065 0.477 15.5835 1.06544 15.5835C1.65389 15.5835 2.13089 15.1065 2.13089 14.5181V1.48207C2.13089 0.893626 1.65389 0.416626 1.06544 0.416626Z"
                      fill="var(--priority{task[1].priority.name})"
                    />
                  </svg>
                </div>
              </div>
            </a>
          {/if}
        {/each}
      </div>
    </div>
  {/each}
</div>

<style>
  ::-webkit-scrollbar {
    height: 0px;
    width: 0px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }
  .t-wrapper {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 0.5rem;
  }

  .t-container {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1.2rem 1.2rem 1.2rem;
    width: 275px;
    margin-right: 31px;
    border-radius: 5px;
    min-height: 38rem;
    overflow-x: hidden;
    background: white;
    box-shadow: 0px 0px 10px rgba(219, 219, 220, 0.65);
  }

  .t-ctn-line {
    position: absolute;
    height: 4px;
    width: 100%;
    top: 0;
    left: 0;
    background-color: #0d192c;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .top {
    margin-top: 1.5rem;
    align-items: center;
  }

  .t-title {
    font-size: 1.1em;
    font-weight: 500;
    color: #3c434b;
  }

  .add-img {
    padding: 0.05rem 0.5rem;
    font-size: 1.1em;
    color: #3c434b;
    margin-left: auto;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(219, 219, 220, 0.65);
    cursor: pointer;
  }

  .task-ctn {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 10px #00000040;
    color: #91929e;
    border-radius: 12px;
    padding: 0.85rem;
    margin-top: 1rem;
    /* background-color: #cacccf; */
    transition: all 650ms;
    /* border: 1
px
 solid #0d192c; */
    cursor: pointer;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .task-id {
    font-size: 0.75em;
    margin-bottom: 0.1rem;
  }

  .task-name {
    color: black;
    font-size: 0.875em;
    transition: all 650ms;
    -webkit-transition: all 650ms;
    -o-transition: all 650ms;
    -moz-transition: all 650ms;
  }

  .flex-start {
    align-items: flex-start;
  }

  .task-chat {
    margin-left: auto;
    padding: 0rem 0.4rem;
    border: 1px solid #f1f2f2;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 5px;
    cursor: pointer;
  }

  .task-view {
    margin-left: 1rem;
    padding: 0rem 0.4rem;
    border: 1px solid #f1f2f2;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 5px;
    cursor: pointer;
  }

  .task-description {
    font-size: 0.625em;
    font-weight: 500;
    margin-bottom: 1rem;
    /* max-height: 8rem; */
    min-height: 3rem;
  }

  .comments {
    margin-bottom: 0.55rem;
    align-items: center;
  }

  .user-img {
    border-radius: 50%;
    display: flex;
    width: 1.5rem;
    height: 1.5rem;
    overflow: hidden;
  }

  .task-comments {
    margin: 0 0.4rem;
    font-size: 0.68em;
    font-weight: 600;
    color: #6f7277;
    transition: all 650ms;
    -webkit-transition: all 650ms;
    -o-transition: all 650ms;
    -moz-transition: all 650ms;
  }

  .task-read {
    cursor: pointer;
  }

  .unread {
    cursor: pointer;
    filter: invert(12%) sepia(100%) saturate(5537%) hue-rotate(358deg)
      brightness(98%) contrast(113%);
  }

  .t-estimate {
    padding: 0.4rem 0.8rem 0.4rem 0.5rem;
    background-color: black;
    border-radius: 8px;
    transition: all 650ms;
  }

  .estimate-clock {
    margin-right: 0.4rem;
    display: flex;
  }

  .clock {
    fill: white;
    transition: all 650ms;
  }

  .task-estimate {
    color: white;
    font-size: 0.68em;
    transition: all 650ms;
    -webkit-transition: all 650ms;
    -o-transition: all 650ms;
    -moz-transition: all 650ms;
  }

  .onHover .task-estimate {
    transition: all 650ms;
    -webkit-transition: all 650ms;
    -o-transition: all 650ms;
    -moz-transition: all 650ms;
  }

  .task-priority {
    margin-left: auto;
  }

  .err {
    background: red !important;
  }

  .t-approval {
    background: #0081ff;
    padding: 0.4rem;
    border-radius: 8px;
    margin-top: 0.55rem;
    cursor: pointer;
  }

  .task-approval {
    font-size: 0.7em;
    color: white;
    margin-left: 0.5rem;
  }

  .onHover {
    color: white;
    box-shadow: 0px 0px 10px 0.2px #d6d6d6cc;
    transition: all 650ms;
    background-color: rgb(17, 17, 17);
  }

  .onHover .task-name {
    color: white;
    transition: all 450ms;
    -webkit-transition: all 450ms;
    -o-transition: all 450ms;
    -moz-transition: all 450ms;
  }

  .onHover .task-comments {
    color: white;
    transition: all 650ms;
    -webkit-transition: all 650ms;
    -o-transition: all 650ms;
    -moz-transition: all 650ms;
  }

  .onHover .t-estimate {
    background-color: white;
    transition: all 650ms;
  }

  .onHover .task-estimate {
    color: black;
  }

  .onHover .clock {
    fill: black;
    transition: all 650ms;
  }

  @media only screen and (max-width: 1100px) {
    .t-wrapper {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      padding-bottom: 0.5rem;
    }

    .tasksLoadingList {
      display: flex;
      flex-direction: row;
      overflow-y: auto;
      padding: 0.5rem;
    }

    .tasksLoadingList a {
      margin-right: 1rem;
    }

    .t-container {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0.5rem 1.2rem 1.2rem 1.2rem;
      width: auto;
      margin-right: 31px;
      border-radius: 5px;
      min-height: auto;
      overflow-x: hidden;
      background: white;
      box-shadow: 0px 0px 10px rgb(219 219 220 / 65%);
    }

    .task-ctn {
      display: flex;
      flex-direction: column;
      box-shadow: 0px 0px 10px #00000040;
      color: #91929e;
      border-radius: 12px;
      padding: 0.85rem;
      margin-top: 1rem;
      transition: all 650ms;
      cursor: pointer;
      max-width: 257px;
      min-width: 257px;
    }
  }

  .display {
    display: flex;
  }

  .none {
    display: none;
  }
</style>
